import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api';
import { TokenService } from './token';
import { NavigationService } from './navigation';
import { ProfileService } from './profile';
import { Token } from '../models/token.model';
import { LoginRequest, RegisterRequest, AuthResponse, RegisterResponse } from '../models/user.model';

// Legacy interfaces - keeping for backward compatibility during transition
export interface LoginPayload {
  username: string;
  password: string;
}

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: string;
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface SetPasswordRequest {
  token: string;
  password: string;
}

export interface CheckVerifyToken {
  verification_token:string,
  exist:boolean
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private api = inject(ApiService);
  private tokenService = inject(TokenService);
  private navigation = inject(NavigationService);
  private profileService = inject(ProfileService);

  /**
   * Login with email and password using new API endpoint
   */
  login(payload: LoginRequest): Observable<AuthResponse> {
    return this.api.post<AuthResponse>('users/login', payload);
  }

  /**
   * Register new user account
   */
  register(payload: RegisterRequest): Observable<RegisterResponse> {
    return this.api.post<RegisterResponse>('users/register', payload);
  }

  /**
   * Legacy login method - keeping for backward compatibility during transition
   */
  legacyLogin(payload: LoginPayload): Observable<LoginResponse> {
    return this.api.post<LoginResponse>('accounts/auth/login', payload);
  }

  /**
   * Request password reset link
   */
  forgotPassword(payload: ForgotPasswordRequest): Observable<any> {
    return this.api.post<any>('accounts/auth/forgot-password', payload);
  }

  /**
   * Set new password using reset token
   */
  setPassword(payload: SetPasswordRequest): Observable<any> {
    return this.api.post<any>('accounts/auth/reset-password', payload);
  }

  doLogout(){
    this.profileService.clearProfile();
    this.tokenService.clearToken();
    this.navigation.navigateTo('/');
  }
  /**
   * Validate password reset token
   */
  getNewAccessToken(token: string): Observable<LoginResponse> {
    return this.api.post<LoginResponse>(`accounts/auth/refresh-token`, { refresh_token: token });
  }

  checkVerifyToken(token:string | null):Observable<CheckVerifyToken> {
    return this.api.post<CheckVerifyToken>('accounts/auth/verify-token',{token})
  }

  resetPassword(password:any):Observable<any> {
    return this.api.post<any>('accounts/auth/reset-password',password)
  }
}
